import { inject, injectable } from 'tsyringe';
import { type IBuyerUserTokenRepository } from 'application/repositorySchemas/IBuyerUserTokenRepository';
import { type IBuyerSupportChatRepository } from 'application/repositorySchemas/IBuyerSupportChatRepository';
import { type IBuyerSupportSendChatClient } from 'interfaceAdapter/gatewaySchemas/IBuyerSupportSendChatClient';

@injectable()
export class BuyerSupportChatRepository implements IBuyerSupportChatRepository {
    constructor(
        @inject('IBuyerUserTokenRepository')
        public readonly buyerUserToken: IBuyerUserTokenRepository,
        @inject('IBuyerSupportSendChatClient')
        public readonly sendChatClient: IBuyerSupportSendChatClient,
    ) {}

    public async send(message: string): Promise<void> {
        const { message: resMessage } = await this.sendChatClient.post({
            token: this.buyerUserToken.get() || '',
            message,
        });

        if (resMessage) {
            throw new Error(resMessage);
        }
    }
}

